export const LOAD_CURRENT_USER = 'user/LOAD_CURRENT_USER';
export const TOGGLE_EMAIL_CONFIRMATION = '/user/TOGGLE_EMAIL_CONFIRMATION';
